// Vuex - Actions (myprotein)

// namespace
export const MYPROTEIN= 'myprotein'

// mutations
export const SET_PROTEIN_QUIZ = 'SET_PROTEIN_QUIZS'            // STEP 1. 알쏭달쏭 단백질 퀴즈 문제 저장 총 8문제
export const SET_PROTEIN_SELF_CHECK = 'SET_PROTEIN_SELF_CHECK'  // STEP 2. 단백질 자가진단 문항 별 저장 총 10개
export const SET_PROTEIN_PURPOSE = 'SET_PROTEIN_PURPOSE'        // STEP 3. 단백질 섭취목적 정보저장 문항 3개

// SET_PROTEIN_PURPOSE 저장 시..
// 1.건강을 위해 필수 영양소인 ... 선택 =  몸무게 x 1.2
// 2.탄탄한 몸을 위해 체지방 조절 .. 선택 = 몸무게 x 1.2
// 3.근육 증가를 원해요 선택 = 몸무게 x 1.5



// WEBPACK FOOTER //
// ./src/store/actions/myprotein.js